import type { RequestConfig } from "@umijs/max";
import { history } from "@umijs/max";
import { message } from "antd";
import { clearAuthToken, getAuthToken } from "@/utils/authStorage";

const loginPath = "/user/login";

const errorHandler = (_error: any) => {
  // const { response } = error || {};
  // const status = response?.status;
  //
  // if (status === 401) {
  //   清理本地登录态
  //   if (window.location.pathname !== loginPath) {
  //     message.error("登录已过期，请重新登录");
  //     history.replace(loginPath);
  //   }
  //   return;
  // }
  //
  //
  // if (status === 403) {
  //   message.error('没有权限访问该资源');
  //   return;
  // }
  //
  // if (status === 500) {
  //   message.error('服务器内部错误，请稍后重试');
  //   return;
  // }
  //
  // if (error?.message) {
  //   message.error(error.message);
  // }
};

export const errorConfig: Partial<RequestConfig> = {
  requestInterceptors: [
    (config: any) => {
      const token = getAuthToken();
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
  ],

  // 响应拦截器：处理后端统一响应格式 {success, errorCode, errorMessage, data}
  responseInterceptors: [
    (response: any) => {
      const { data } = response;
      if (data && data.success === false) {
        if (data.errorCode === 401) {
          clearAuthToken();
          if (window.location.pathname !== loginPath) {
            message.error("登录已过期，请重新登录");
            history.replace(loginPath);
          }
        }
        // 其余业务错误不在这里弹窗，交给各页面自己判断 success 字段
      }
      return response;
    },
  ],

  errorConfig: {
    errorHandler,
    // errorThrower: (res: any) => {
    //   const { success, errorMessage: msg, errorCode } = res as API.Result;
    //   if (!success && errorCode && errorCode !== 200) {
    //     const error: any = new Error(msg || "请求失败");
    //     error.name = "BizError";
    //     error.info = res;
    //     throw error;
    //   }
    // },
  },
};
